import { InveniasNamespace } from 'datasource-service-lib';
import { EntityControllerService } from 'entity-picker-lib';
import { IEntity } from 'interfaces-lib';
import { runtimeEnvironment } from '../environments/environment';

export class ChromeUrlMonitor {
  private static launchTabInfo: {
    tabId: number;
    windowId: number;
    url: string;
  } = { tabId: undefined, windowId: 0, url: null };
  private static entity: IEntity;

  private constructor() {}

  static start(entityControllerService: EntityControllerService): void {
    console.log('ChromeUrlMonitor started');

    if (chrome.tabs === undefined) {
      console.log('No permission for "tabs".');
      return;
    }

    // factory function - get from IDataSource
    let getEntity: (url: string) => IEntity | undefined;
    if (runtimeEnvironment.origin.namespace === InveniasNamespace.name) {
      getEntity = ChromeUrlMonitor.inveniasUrlParser;
    }

    chrome.tabs.query({ active: true, currentWindow: true }, (tabs) => {
      console.log('queryTab (launch)', tabs[0]);
      this.launchTabInfo = {
        tabId: tabs[0].id,
        windowId: tabs[0].windowId,
        url: tabs[0].url,
      };
      console.log('launchTabInfo', this.launchTabInfo);
      this.entity = getEntity(tabs[0].url);
      entityControllerService.entitySelected(this.entity);
    });

    // don't include this if we're in a popup
    chrome.tabs.onUpdated.addListener((tabId, changeInfo, tab) => {
      // console.log('onUpdated', tab, changeInfo);
      // developer tools doesn't have a url - do we need to check if windowId is same as query windowId?
      if (this.isSameTab(tab.id, tab.windowId, tab.url)) {
        const entity = getEntity(tab.url);
        if (!ChromeUrlMonitor.sameEntity(this.entity, entity)) {
          this.entity = entity; // set early so we don't keep getting the same record
          entityControllerService.entitySelected(this.entity);
        }
      }
    });
  }

  private static isSameTab(tabId: number, windowId: number, url: string): boolean {
    if (tabId !== this.launchTabInfo.tabId || windowId !== this.launchTabInfo.windowId) {
      return false;
    }

    const urlOrigin = new URL(url).origin;
    const runtimeOrigin = new URL(runtimeEnvironment.origin.url).origin;
    return urlOrigin === runtimeOrigin;
  }

  private static inveniasUrlParser(url: string): IEntity | undefined {
    // TODO: consider splitting pathname and returning 2nd part
    // example: https://kyloedev.invenias.com/web/people/facd4271-377e-4c7a-a3de-4f45c61b6cd3/documents

    if (!url) {
      return undefined;
    }

    console.log('getEntity', url);

    const pathMaker = (type) => `/web/${type}/`;

    const srcUrl = new URL(url);
    const types = ['people', 'companies', 'assignments', 'programmes'];
    const foundType = types.find((t) => {
      const path = pathMaker(t);
      return srcUrl.pathname.startsWith(path);
    });

    if (foundType) {
      const GUID_LENGTH = 36;
      const path = pathMaker(foundType);
      return {
        type: foundType,
        id: srcUrl.pathname.substr(path.length, GUID_LENGTH),
      };
    }

    return undefined;
  }

  private static sameEntity(a: IEntity | undefined, b: IEntity | undefined): boolean {
    return a?.id === b?.id && a?.type === b?.type;
  }
}
